import {
  mobigestorRoutes,
  mobigestorWithoutDealer,
  routesWithConsultor,
  routesWithoutDealer,
  functionRoutesWithDealer,
} from 'config/routes';

function getRoutes({
  hasDealer = false,
  isConsultant = false,
  hasResaleBuy = false,
  hasResaleSell = false,
} = {}) {
  if (isConsultant) {
    mobigestorRoutes.routes = routesWithConsultor;
    return mobigestorRoutes.routes;
  }
  if (hasDealer) {
    mobigestorRoutes.routes = functionRoutesWithDealer(
      hasResaleBuy,
      hasResaleSell
    );
    return mobigestorRoutes.routes;
  }
  mobigestorWithoutDealer.routes = routesWithoutDealer;
  return mobigestorWithoutDealer.routes;
}
export default getRoutes;
